<template>
  <div class="supplier-manage bj">
    <div class="title">
      <div class="form jn-form-style">
        <div class="form-item btn-wrap">
          <el-button
            type="primary"
            style="margin-left: 5px"
            icon="el-icon-refresh"
            class="refresh"
            @click="onHandleRefresh"
          ></el-button>
          <el-button @click="onHandleCreate" type="primary">新 增</el-button>
        </div>

        <div class="form-item">
          <el-select
            v-model="formData.logistic_business_id"
            placeholder="选择集配中心"
            clearable
          >
            <el-option
              v-for="item of logisticsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.buyer_name"
            placeholder="请输入业务员名称"
            clearable
          ></el-input>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.team_name"
            placeholder="请输入所属小组"
            clearable
          ></el-input>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.buyer_mobile"
            placeholder="请输入采购电话"
            clearable
          ></el-input>
        </div>
        <div class="form-item">
          <el-select
            v-model="formData.state"
            clearable
            placeholder="请选择状态"
          >
            <el-option label="全部状态" value=""></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="2"></el-option>
          </el-select>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.supplier_name"
            placeholder="请输入供应商名称"
            clearable
          ></el-input>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.supplier_mobile"
            placeholder="请输入供应商电话"
            clearable
          ></el-input>
        </div>

        <el-button @click="onHandleSearch" type="primary" icon="el-icon-search"
          >查询</el-button
        >
        <el-button type="primary" @click="onHandleExport">导 出</el-button>
      </div>
    </div>
    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column type="index" width="80px" align="center" label="序号">
        </el-table-column>
        <el-table-column prop="buyer_name" align="center" label="业务员">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.buyer_name) }}
          </template>
        </el-table-column>
        <el-table-column prop="supplier_name" align="center" label="发品供应商">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.supplier_name) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="on_sale_count"
          align="center"
          label="在售商品数量"
        >
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.on_sale_count) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="off_sale_count"
          align="center"
          label="下架商品数量"
        >
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.off_sale_count) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="is_limit_slot"
          align="center"
          label="是否限制坑位"
        >
          <template slot-scope="scope">
            <span
              :class="scope.row.is_limit_slot ? 'success-text' : 'danger-text'"
            >
              {{ scope.row.is_limit_slot ? "是" : "否" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="slot_count" align="center" label="坑位数">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.slot_count) }}
          </template>
        </el-table-column>
        <el-table-column prop="can_add_stock" align="center" label="加库存">
          <template slot-scope="scope">
            <span
              :class="scope.row.can_add_stock ? 'success-text' : 'danger-text'"
            >
              {{ scope.row.can_add_stock ? "✓" : "✗" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="can_reduce_stock" align="center" label="减库存">
          <template slot-scope="scope">
            <span
              :class="
                scope.row.can_reduce_stock ? 'success-text' : 'danger-text'
              "
            >
              {{ scope.row.can_reduce_stock ? "✓" : "✗" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="can_off_goods" align="center" label="下架商品">
          <template slot-scope="scope">
            <span
              :class="scope.row.can_off_goods ? 'success-text' : 'danger-text'"
            >
              {{ scope.row.can_off_goods ? "✓" : "✗" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="can_create_goods"
          align="center"
          label="新建商品"
        >
          <template slot-scope="scope">
            <span
              :class="
                scope.row.can_create_goods ? 'success-text' : 'danger-text'
              "
            >
              {{ scope.row.can_create_goods ? "✓" : "✗" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="can_edit_goods" align="center" label="编辑商品">
          <template slot-scope="scope">
            <span
              :class="scope.row.can_edit_goods ? 'success-text' : 'danger-text'"
            >
              {{ scope.row.can_edit_goods ? "✓" : "✗" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="can_change_image" align="center" label="换图">
          <template slot-scope="scope">
            <span
              :class="
                scope.row.can_change_image ? 'success-text' : 'danger-text'
              "
            >
              {{ scope.row.can_change_image ? "✓" : "✗" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="onHandleEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="editDialogVisible"
      v-if="editDialogVisible"
      width="50%"
      class="dialog supplier-dialog"
      center
    >
      <div class="contents">
        <el-form
          :model="editForm"
          :rules="editRules"
          ref="editForm"
          label-width="auto"
          class="demo-ruleForm"
        >
          <!-- 回显信息 -->
          <el-form-item label="供应商">
            <div>{{ editForm.supplier_name }}</div>
            <!-- <el-input v-model="editForm.supplier_name" disabled></el-input> -->
          </el-form-item>
          <el-form-item label="采购">
            <div>{{ editForm.buyer_name }}</div>
            <!-- <el-input v-model="editForm.buyer_name" disabled></el-input> -->
          </el-form-item>
          <el-form-item label="在售商品">
            <div>{{ editForm.on_sale_count }}</div>
            <!-- <el-input v-model="editForm.on_sale_count" disabled></el-input> -->
          </el-form-item>
          <el-form-item label="下架商品">
            <div>{{ editForm.off_sale_count }}</div>
            <!-- <el-input v-model="editForm.off_sale_count" disabled></el-input> -->
          </el-form-item>
          <!-- <div class="mb-15">供应商：{{ editForm.supplier_name }}</div>
          <div class="mb-15">采购：{{ editForm.buyer_name }}</div>
          <div class="mb-15">在售商品：{{ editForm.on_sale_count }}</div>
          <div class="mb-15">下架商品：{{ editForm.on_sale_count }}</div> -->
          <!-- <el-row :gutter="20">
            <el-col :span="12">
              
            </el-col>
            <el-col :span="12">
              <el-form-item label="采购">
                <div>{{ editForm.buyer_name }}</div>
                <el-input v-model="editForm.buyer_name" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="在售商品">
                <div>{{ editForm.on_sale_count }}</div>
                <el-input v-model="editForm.on_sale_count" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="下架商品">
                <div>{{ editForm.off_sale_count }}</div>
                <el-input v-model="editForm.off_sale_count" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- 限制坑位 -->
          <el-form-item label="限制坑位" prop="is_limit_slot">
            <el-radio-group v-model="editForm.is_limit_slot" class="mr30">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <el-checkbox v-model="editForm.is_limit_slot_allow_change"
              >允许采购更改</el-checkbox
            >
            <el-checkbox v-model="editForm.is_limit_slot_apply_all"
              >应用于该采购全部供应商</el-checkbox
            >
          </el-form-item>

          <el-form-item label="坑位数" prop="slot_count">
            <el-input
              v-model="editForm.slot_count"
              :min="0"
              :max="9999"
              :controls="false"
              style="width: 30%"
            ></el-input>
          </el-form-item>

          <!-- 加库存 -->
          <el-form-item label="加库存">
            <el-radio-group v-model="editForm.can_add_stock" class="mr30">
              <el-radio :label="1">允许</el-radio>
              <el-radio :label="0">不允许</el-radio>
            </el-radio-group>
            <el-checkbox v-model="editForm.can_add_stock_allow_change"
              >允许采购更改</el-checkbox
            >
            <el-checkbox v-model="editForm.can_add_stock_apply_all"
              >应用于该采购全部供应商</el-checkbox
            >
          </el-form-item>

          <!-- 减库存 -->
          <el-form-item label="减库存">
            <el-radio-group v-model="editForm.can_reduce_stock" class="mr30">
              <el-radio :label="1">允许</el-radio>
              <el-radio :label="0">不允许</el-radio>
            </el-radio-group>
            <el-checkbox v-model="editForm.can_reduce_stock_allow_change"
              >允许采购更改</el-checkbox
            >
            <el-checkbox v-model="editForm.can_reduce_stock_apply_all"
              >应用于该采购全部供应商</el-checkbox
            >
          </el-form-item>

          <!-- 下架商品 -->
          <el-form-item label="下架商品">
            <el-radio-group v-model="editForm.can_off_goods" class="mr30">
              <el-radio :label="1">允许</el-radio>
              <el-radio :label="0">不允许</el-radio>
            </el-radio-group>
            <el-checkbox v-model="editForm.can_off_goods_allow_change"
              >允许采购更改</el-checkbox
            >
            <el-checkbox v-model="editForm.can_off_goods_apply_all"
              >应用于该采购全部供应商</el-checkbox
            >
          </el-form-item>

          <!-- 新建商品 -->
          <el-form-item label="新建商品">
            <el-radio-group v-model="editForm.can_create_goods" class="mr30">
              <el-radio :label="1">允许</el-radio>
              <el-radio :label="0">不允许</el-radio>
            </el-radio-group>
            <el-checkbox v-model="editForm.can_create_goods_allow_change"
              >允许采购更改</el-checkbox
            >
            <el-checkbox v-model="editForm.can_create_goods_apply_all"
              >应用于该采购全部供应商</el-checkbox
            >
          </el-form-item>

          <!-- 编辑商品 -->
          <el-form-item label="编辑商品" class="mb30">
            <el-radio-group v-model="editForm.can_edit_goods" class="mr30">
              <el-radio :label="1">允许</el-radio>
              <el-radio :label="0">不允许</el-radio>
            </el-radio-group>
            <el-checkbox v-model="editForm.can_edit_goods_allow_change"
              >允许采购更改</el-checkbox
            >
            <el-checkbox v-model="editForm.can_edit_goods_apply_all"
              >应用于该采购全部供应商</el-checkbox
            >
          </el-form-item>

          <!-- 换图 -->
          <el-form-item label="换图">
            <el-radio-group v-model="editForm.can_change_image" class="mr30">
              <el-radio :label="1">允许</el-radio>
              <el-radio :label="0">不允许</el-radio>
            </el-radio-group>
            <el-checkbox v-model="editForm.can_change_image_allow_change"
              >允许采购更改</el-checkbox
            >
            <el-checkbox v-model="editForm.can_change_image_apply_all"
              >应用于该采购全部供应商</el-checkbox
            >
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onHandleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import { downLoadFlowBlob } from "@/utils/tools/base";

export default {
  name: "JiCaiSupplierManage",
  data() {
    return {
      loading: false,
      logisticsList: [], // 集配中心列表
      formData: {
        logistic_business_id: "",
        buyer_name: "",
        team_name: "",
        buyer_mobile: "",
        state: "",
        supplier_name: "",
        supplier_mobile: "",
        page: 1,
        pageSize: 50,
      },
      formDataClone: {},
      tableData: [],
      currentPage: 1,
      total: 0,
      dialogTitle: "新增",
      editDialogVisible: false,
      editForm: {
        id: "",
        supplier_name: "",
        buyer_name: "",
        on_sale_count: "",
        off_sale_count: "",
        // 限制坑位
        is_limit_slot: 0,
        slot_count: 0,
        is_limit_slot_allow_change: false,
        is_limit_slot_apply_all: false,
        // 加库存
        can_add_stock: 0,
        can_add_stock_allow_change: false,
        can_add_stock_apply_all: false,
        // 减库存
        can_reduce_stock: 0,
        can_reduce_stock_allow_change: false,
        can_reduce_stock_apply_all: false,
        // 下架商品
        can_off_goods: 0,
        can_off_goods_allow_change: false,
        can_off_goods_apply_all: false,
        // 新建商品
        can_create_goods: 0,
        can_create_goods_allow_change: false,
        can_create_goods_apply_all: false,
        // 编辑商品
        can_edit_goods: 0,
        can_edit_goods_allow_change: false,
        can_edit_goods_apply_all: false,
        // 换图
        can_change_image: 0,
        can_change_image_allow_change: false,
        can_change_image_apply_all: false,
      },
      editFormClone: {},
      editRules: {
        slot_count: [
          { required: true, message: "请输入坑位数", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.formDataClone = cloneDeep(this.formData);
    this.editFormClone = cloneDeep(this.editForm);
    this.getTableData();
    this.getAjaxLogisticsList();
  },
  methods: {
    /**
     * 获取集配中心列表
     */
    async getAjaxLogisticsList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.logisticsList = data;
      } catch (err) {
        console.log("ajax getAjaxLogisticsList err", err);
      }
    },
    /**
     * 获取列表数据
     */
    getTableData() {
      this.loading = true;
      const params = {
        ...this.formData,
      };
      // TODO: 替换实际接口
      this.$api.general
        .buyerList(params)
        .then((res) => {
          console.log(res, "获取数据");
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /**
     * 搜索
     */
    onHandleSearch() {
      this.formData.page = 1;
      this.currentPage = 1;
      this.getTableData();
    },
    /**
     * 重置
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.currentPage = 1;
      this.getTableData();
    },
    /**
     * 导出
     */
    onHandleExport() {
      const params = {
        ...this.formData,
      };
      delete params.page;
      delete params.pageSize;
      // TODO: 替换实际导出接口
      this.$api.general.jiCaiSupplierManageExport(params).then((res) => {
        downLoadFlowBlob(res, res?.filename);
      });
    },
    /**
     * 新增
     */
    onHandleCreate() {
      this.dialogTitle = "新增";
      this.editForm = {
        ...this.editFormClone,
      };
      this.editDialogVisible = true;
    },
    /**
     * 编辑
     */
    onHandleEdit(row) {
      this.dialogTitle = "编辑";
      this.editForm = {
        id: row.id,
        supplier_name: row.supplier_name || "",
        buyer_name: row.buyer_name || "",
        on_sale_count: row.on_sale_count || "0",
        off_sale_count: row.off_sale_count || "0",
        // 限制坑位
        is_limit_slot: row.is_limit_slot ? 1 : 0,
        slot_count: row.slot_count || 0,
        is_limit_slot_allow_change: row.is_limit_slot_allow_change || false,
        is_limit_slot_apply_all: row.is_limit_slot_apply_all || false,
        // 加库存
        can_add_stock: row.can_add_stock ? 1 : 0,
        can_add_stock_allow_change: row.can_add_stock_allow_change || false,
        can_add_stock_apply_all: row.can_add_stock_apply_all || false,
        // 减库存
        can_reduce_stock: row.can_reduce_stock ? 1 : 0,
        can_reduce_stock_allow_change:
          row.can_reduce_stock_allow_change || false,
        can_reduce_stock_apply_all: row.can_reduce_stock_apply_all || false,
        // 下架商品
        can_off_goods: row.can_off_goods ? 1 : 0,
        can_off_goods_allow_change: row.can_off_goods_allow_change || false,
        can_off_goods_apply_all: row.can_off_goods_apply_all || false,
        // 新建商品
        can_create_goods: row.can_create_goods ? 1 : 0,
        can_create_goods_allow_change:
          row.can_create_goods_allow_change || false,
        can_create_goods_apply_all: row.can_create_goods_apply_all || false,
        // 编辑商品
        can_edit_goods: row.can_edit_goods ? 1 : 0,
        can_edit_goods_allow_change: row.can_edit_goods_allow_change || false,
        can_edit_goods_apply_all: row.can_edit_goods_apply_all || false,
        // 换图
        can_change_image: row.can_change_image ? 1 : 0,
        can_change_image_allow_change:
          row.can_change_image_allow_change || false,
        can_change_image_apply_all: row.can_change_image_apply_all || false,
      };
      this.editDialogVisible = true;
    },
    /**
     * 提交
     */
    onHandleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const params = {
            ...this.editForm,
          };
          // TODO: 替换实际接口
          this.$api.general
            .jiCaiSupplierManageCreate(params)
            .then(() => {
              this.$message({
                type: "success",
                message: this.dialogTitle === "新增" ? "添加成功" : "修改成功",
              });
              this.editDialogVisible = false;
              this.getTableData();
            })
            .catch(() => {});
        }
      });
    },
    handleSizeChange(val) {
      this.formData.page = 1;
      this.formData.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.formData.page = val;
      this.currentPage = val;
      this.getTableData();
    },
  },
};
</script>
<style lang="scss" scoped>
.supplier-manage {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .mr30 {
    margin-right: 30px;
  }
  .mb30 {
    margin-bottom: 30px;
  }

  .title {
    background: #ffffff;
    padding: 13px 15px;
    box-sizing: border-box;
    display: flex;
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .contents {
    padding: 20px;
    box-sizing: border-box;
  }

  .success-text {
    color: #67c23a;
  }

  .danger-text {
    color: #f56c6c;
  }
}

// 弹窗样式
.supplier-dialog {
  ::v-deep .el-dialog {
    max-width: 1200px;
  }

  .permission-row {
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    .checkbox-col {
      display: flex;
      align-items: center;
      gap: 20px;
      // padding-top: 8px;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
